module.exports = __webpack_public_path__ + "static/media/student_excersize_image.ed6f5bf2.png";